import React from 'react'
import Produkt from './produkt.jsx'

const Lernvideos = (props) => {


    const suchenDiv=(
      
            <div key={-34} style={{display:'flex', width:'100%', marginLeft:'auto', marginRight:'0', padding:'2px',backgroundColor:'lightgray',color:'black', borderRadius:'6px'}}>
                <input type="search" style={{marginLeft:'10px', border:'0', outline:'none', backgroundColor:'lightgray', width:'400px'}}  value={props.suchenText} onChange={props.setProduktSuchenText} placeholder={props.getString('$STR_0248')}/>
                <div style={{width:'30px', height:'30px', cursor:'pointer', marginTop:'11px'}} onClick={props.clearSearch}><i className="material-icons"> close </i></div>

            </div>
    )

    function produktRow(produkt){

        if (produkt.ist_oeffentlich===0) return null

        return <Produkt
                key={produkt.id}
                produkt={produkt}
                gekauft={props.gekauft}
                zeigeProdukt={props.zeigeProdukt}
                root="showProduct"    
                inDenEinkaufswagen={props.inDenEinkaufswagen}      
                />

    }   

    return(
      
            <div className="text-center showin" style={{color:'lightgrey', backgroundColor:'#101010',marginTop:'55px', overflowY:'auto'}}>
                <div className="row">
                    <div className="col-12" >    
                        <h2 style={{marginTop:'25px'}}>{props.getString('$STR_0128')}</h2>
                        <p className="normal-font">{props.getString('$STR_0250')}</p>
                        <div style={{float:'right'}}>{suchenDiv}</div>
                    </div>
                </div>
                <div className="row">                      
                    {props.filtered_produkt_lektionen.map(produktRow)}  
                </div>
            </div>
    )

}

export default Lernvideos